import { useState } from "react";
import { Image } from "./image";

export const Gallery = (props) => {
  const [activeVideo, setActiveVideo] = useState(null);

  const closeVideo = () => setActiveVideo(null);

  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title mb-4'>
          <h2 className="goldscreen">How managers are using CrewCoin</h2>
          <div className="cc-example-block">
            <div className="row">
              <div className="col-sm-6">
                <p>⏰ Clock in early → 5  coins</p>
                <p>🧼 Finish side work → 10 coins</p>
                <p>✅ Pick up a shift → 10 coins</p>
                <p>💰 Hit upsell goal → 10 coins</p>
              </div>
              <div className="col-sm-6">
                <p>🍕 200 coins = Pizza Party</p>
                <p>🎁 200 coins = Gift card</p>
                <p>🎉 500 coins = Preferred shifts</p>
                <p>🏖️ 1000 coins = Day off</p>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <h2 className="goldscreen mt-4">See Crew Coin in Action</h2>
          <hr />
          <div className='portfolio-items'>
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.title}-${i}`} className='col-xs-6 col-xs-3 col-md-3 col-lg-3'>
                    <Image title={d.title} largeImage={d.largeImage} smallImage={d.smallImage} />
                  </div>
                ))
              : 'Loading...'}
            <div className='col-xs-12' style={{ marginBottom: '40px' }}>
              <a
                href='/videos/walkthrough.mp4'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveVideo('/videos/walkthrough.mp4');
                }}
                className='btn btn-custom btn-lg page-scroll'
                style={{ margin: '8px', padding: '14px 28px', fontSize: '18px' }}
              >
                ▶ App Walkthrough
              </a>
              <a
                href='/videos/getting_started.mp4'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveVideo('/videos/getting_started.mp4');
                }}
                className='btn btn-custom btn-lg page-scroll'
                style={{ margin: '8px', padding: '14px 28px', fontSize: '18px' }}
              >
                ▶ Getting Started
              </a>
            </div>
            <div className='col-xs-12'></div>
            <div className='col-xs-12'>
              <a href="https://apps.apple.com/us/app/crew-coin/id1611964163" >
                <img alt="crewcoinlogo" className="appstore" src={'./img/appstore.png'} />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.davwilliams.crewcoinapp">
                <img alt="crewcoinlogo" className="appstore" src={'./img/playstore.png'} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {activeVideo && (
        <div className='cc-video-modal-backdrop' onClick={closeVideo}>
          <div className='cc-video-modal' onClick={(e) => e.stopPropagation()}>
            <button className='cc-video-close' onClick={closeVideo} aria-label='Close video'>×</button>
            <div className='cc-phone-frame'>
              <div className='cc-phone-notch' />
              <video className='cc-phone-video' controls autoPlay playsInline preload='metadata'>
                <source src={activeVideo} type='video/mp4' />
              </video>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
